import { CheckIcon, ChevronsRightIcon, XIcon } from 'lucide-react';
import { FC } from 'react';
import type { TaskRunStatus } from '@/entities/jobs';

type TaskCircleIconProps = {
  status: TaskRunStatus;
};

// Иконка внутри кружка статуса задачи
export const TaskCircleIcon: FC<TaskCircleIconProps> = ({ status }) => {
  switch (status) {
    case 'SUCCESS':
      return <CheckIcon className="size-2.5" strokeWidth={3} />;
    case 'FAILED':
      return <XIcon className="size-2.5" strokeWidth={3} />;
    case 'SKIPPED':
      return <ChevronsRightIcon className="size-2.5" strokeWidth={3} />;
    default:
      return null;
  }
};
